import React from "react";
import clsx from 'clsx';
import { SvgIcon } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

const styles = theme => ({
  root: {
    width: 80,
    height: 80,
    fill: "transparent"
  }
});

class IcCalendar extends React.Component {

  render() {
    const { classes, className } = this.props;

    return <SvgIcon className = { clsx(classes.root, className) }
                    viewBox = { "0 0 80 80" } >
      <path d="M53.3333 6.66675V20.0001" stroke="#004876" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M26.6667 6.66675V20.0001" stroke="#004876" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10 33.3333H70" stroke="#004876" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
      <rect x="10" y="13.3333" width="60" height="60" stroke="#004876" strokeWidth="3"/>
    </SvgIcon>
  }
}

export default withStyles(styles)(IcCalendar);
